define([
	"dojo/_base/declare",
	"csi",
	"csi/action/Controller",
	"csi/comm",
	"csi/comm/PostRequest",
	"file-saver"
], function(declare,csi,Controller,comm,PostRequest, FileSaver) {

	return declare(Controller, {
		toWriter: function() {
			const request = new PostRequest("Export", "ExportConfiguration")
				.addParameter("URL", this.m_urlNode)
				.addParameter("OutputJSON", 0);

			const callServerHttpPost = request.post({ handleAs: "blob" });

			//Save downloaded file
			callServerHttpPost.then((response) => {
				const fileName = this.getRequestActionId();
				FileSaver.saveAs(response.data, fileName); 
			});	

        }
    });
});